// Module
var code = " <div class=\"block is-hidden columns\" id=\"optionSelectorContainer\"> <div class=\"column is-2\" id=\"optionSelectorMenu\">...loading...</div> <div class=\"column\" id=\"optionSelectorContent\">...loading...</div> </div> ";
// Exports
export default code;